import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackbaseCoreModule, ItemModel } from '@backbase/foundation-ang/core';
import { TransactionSigningWidgetExtendedComponent } from './transaction-signing-widget-extended.component';
import { BanescoOTPWebComponent } from './components/banesco-otp-web/banesco-otp-web.component';
import { InputRadioGroupModule } from '@backbase/ui-ang';
import { BanescoOtpVerificationCodeComponent } from './components/banesco-otp-verification-code/banesco-otp-verification-code.component';
import { FormsModule } from '@angular/forms';
import { BnOtpErrorMsgComponent } from './components/banesco-otp-error-msg/banesco-otp-error-msg.component';
import { OtpService } from './services/otp.service';
import { TransactionSigningWidgetModule } from '../../transaction-signing-widget/src/transaction-signing-widget.module';
import { TransactionsListWidgetExtendedModule } from 'transactions-list-widget-extended';
import { of } from 'rxjs';

const widgetProperties: { [key: string]: any } = {
  "pollingCycleTime": 3000,
  "enableResendPushNotification": false
};
const itemModelStub = {
  properties: of({}),
  property: (key: string) => of(widgetProperties[key]),
};


@NgModule({
  declarations: [
    TransactionSigningWidgetExtendedComponent,
    BanescoOTPWebComponent,
    BanescoOtpVerificationCodeComponent,
    BnOtpErrorMsgComponent,
  ],
  imports: [
    CommonModule,
    BackbaseCoreModule.withConfig({
      classMap: { TransactionSigningWidgetExtendedComponent },
    }),
    TransactionSigningWidgetModule,
    InputRadioGroupModule,
    FormsModule,
    TransactionsListWidgetExtendedModule,
  ],
  providers: [
    {
      provide: ItemModel,
      useValue: itemModelStub
    }
  ],
  exports: [TransactionSigningWidgetExtendedComponent]
})
export class TransactionSigningWidgetExtendedModule {}
